import { Box, Button, Flex, Text } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'
import { IFonts } from '@interfaces'
import { useRouter } from 'next/router'
import { createNavLink } from '@utils'
interface IDonationBox {
  title?: string
  description?: string
  buttonLabel?: string
  buttonAction?: () => void
  backgroundUrl?: string
  activeFontFamily?: IFonts
}

const DonationBox = (props: IDonationBox) => {
  const { push, locale } = useRouter()
  const { t } = useTranslation('common')
  const {
    title = t('donation.title'),
    description = t('donation.description'),
    buttonLabel = t('donation.buttonLabel'),
    buttonAction = () => push(createNavLink('about', locale)),
    backgroundUrl = '/img/donate/Hakkimizda_footer.jpg.webp',
    activeFontFamily = 'body',
  } = props

  return (
    <Flex
      flexDirection="column"
      width={{ base: 'full', lg: '400px', xl: '470px' }}
      height="full"
      as="figure"
      bg="white.primary"
    >
      <Flex
        flexDir="column"
        justifyContent="flex-end"
        position="relative"
        bgImage={`url(${
          backgroundUrl || '/img/placeholders/no-image-available-icon.jpeg'
        })`}
        bgPosition="center"
        bgSize="cover"
        bgRepeat="no-repeat"
        height="100%"
        minHeight="468px"
      >
        <Box
          background="linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%)"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            transform: 'rotate(-180deg)',
          }}
        />
        <Flex
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-end"
          px="padding.primary"
          pb="71px"
          zIndex="2"
        >
          <Text
            fontSize={{ base: '2xl', lg: '2xl', xl: '3xl' }}
            fontFamily={activeFontFamily}
            color="white.primary"
            mb={{ base: 4, lg: 6 }}
            as="h2"
            fontWeight="regular"
          >
            {title}
          </Text>
          <Text
            fontSize={{ base: 'sm', lg: 'sm',  md: 'sm' , xl: 'md' }}
            fontFamily={activeFontFamily}
            color="white.primary"
            fontWeight="light"
            maxW="350px"
          >
            {description}
          </Text>
        </Flex>
      </Flex>
      <Button
        size="donate"
        variant="secondary"
        fontFamily={activeFontFamily}
        onClick={buttonAction}
        fontSize="18px"
        fontWeight="regular"
        _hover={{ backgroundColor: 'red.primary3' }}
      >
        {buttonLabel}
      </Button>
    </Flex>
  )
}

export default DonationBox
